import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Spin } from 'antd';
import PropTypes from 'prop-types';

import UsuariFormulari from './usuariFormulari';

import {
    onEnterPerfil,
    onLeavePerfil
} from '../../actions';

import {
    selectorHiHaDadesNecessariesPelPerfil,
    selectorPerfilOnEnterEnCurs
} from '../../selectors/selector_usuari';

import Error from '../commons/error';
import errorBoundaryWrapper from '../commons/errorBoundaryWrapper';
import { RETARD_MILISEGONS_APARICIO_SPINNER } from '../../constants';

class UsuariPerfil extends Component {

    componentDidMount() {
        this.props.onEnterPerfil();
    }

    render() {

        const {
            onEnterPerfilEnCurs,
            hiHaDadesNecessariesPelPerfil
        } = this.props;

        let contingutComponent;

        if (!hiHaDadesNecessariesPelPerfil) {
            contingutComponent = (onEnterPerfilEnCurs) ? null : <Error />;
        } else {
            contingutComponent = <UsuariFormulari esEditable={false} />;
        }

        return (
            <Spin className = 'usuari-spinner' spinning={onEnterPerfilEnCurs} delay={RETARD_MILISEGONS_APARICIO_SPINNER}>
                {contingutComponent}
            </Spin>
        );
    }

    componentWillUnmount() {
        this.props.onLeavePerfil();
    }
}

UsuariPerfil.propTypes = {
    onEnterPerfil: PropTypes.func,
    onLeavePerfil: PropTypes.func,
    onEnterPerfilEnCurs: PropTypes.bool,
    hiHaDadesNecessariesPelPerfil: PropTypes.bool
};

const mapStateToProps = (state) => {
    return {
        onEnterPerfilEnCurs: selectorPerfilOnEnterEnCurs(state),
        hiHaDadesNecessariesPelPerfil: selectorHiHaDadesNecessariesPelPerfil(state),
    };
};


const mapDispatchToProps = {
    onEnterPerfil,
    onLeavePerfil
};

export default errorBoundaryWrapper(connect(mapStateToProps, mapDispatchToProps)(UsuariPerfil));


// WEBPACK FOOTER //
// ./src/components/usuari/usuariPerfil.js